import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent } from '@ionic/angular';  // renamed from Content

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

// NOTE:  suffix "/ngx" ??
// no ngx needed after I ran   "npm install --save @ionic-native/camera@4"
// ref: https://forum.ionicframework.com/t/camera-ionic-3-framework/154704/3
// tried again with:   npm install --save @ionic-native/camera@latest
import { Camera, CameraOptions, CameraPopoverOptions } from '@ionic-native/camera/ngx';

import { RuntimeService } from 'src/app/services/runtime/runtime.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { CommonService } from 'src/app/services/common/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { PhotoUploadStatus } from 'src/app/services/global/structure';

@Component({   // error caused by including "camera" -- why?  Fixed by "npm install --save @ionic-native/camera@latest"
  selector: 'mycamera',
  templateUrl: './mycamera.component.html',
  styleUrls: ['./mycamera.component.scss'],
})
export class MycameraComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  
  @Input() pageName:string; //@Input('pageName') pageName;
  @Output() outPhotoCount: EventEmitter<any> = new EventEmitter<any>();
  @Output() outPhotoUploadStatus: EventEmitter<any> = new EventEmitter<any>();

  private consoleLog:boolean = false;

  public ShowNativeCamera:boolean = false;
  public HidePhotoDisplayOutput:boolean = true;
  public isIncludePhoto:boolean = false;
  public ImgSrcBase64Image:any;
  private Base64ImageData:any;

  // data used in API call
  private PhotoContext:any = {};

  // multiple photo displays
  public DisplayPhotos: any;
  public UploadPhotos: any;
  public PhotoTotal:number = 0;
  public PhotoUploadStatus:PhotoUploadStatus = new PhotoUploadStatus();

  // https://academind.com/learn/angular/snippets/angular-image-upload-made-easy/
  private selectedFile: File;
  private FileType:string;
  private Upload_1File_2Base64:number = 0;

  //private _options;  // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-camera/
  private options: CameraOptions = {};

  // NOTE:  I added this to get around issue of including Camera in the Component list
  // NOTE:  I added this to get around issue of including Camera in the Component list
  // NOTE:  I added this to get around issue of including Camera in the Component list
  // - not sure if this will really work for taking pictures but worth a try
  //private cameraX: Camera = new Camera();   // see NOTE1
  // - not sure if this will really work for taking pictures but worth a try
  // NOTE:  I added this to get around issue of including Camera in the Component list
  // NOTE:  I added this to get around issue of including Camera in the Component list
  // NOTE:  I added this to get around issue of including Camera in the Component list
  // NOTE:  I added this to get around issue of including Camera in the Component list
  
  constructor(
      public runtimeProvider: RuntimeService
    , public globalProvider: GlobalService
    , private commonProvider:CommonService
    , public translate: TranslateService
    , public apiProvider: ApiService
    , public zone: NgZone 
    , public events: Events
    // NOTE1: I am trying instead to include "camera" in the variable list above
    , public camera: Camera   // <<<<<<<<<<<<<<<<<<<  
    //, public cameraOptions: CameraOptions
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_mycamera;
    if (this.consoleLog) console.log('mycamera.ctor - LifeCycle');
    this.Initialize("ctor");
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('mycamera.ngOnInit - ' + this.pageName + ' - LifeCycle');
    this.Initialize("ngOnInit");
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('mycamera.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // --------------  INITIALIZE   -----------------------
  // ----------------------------------------------------
  Initialize(context:string)
  {
    if (this.consoleLog) console.log('mycamera.Initialize');
    this.isIncludePhoto = false;
    this.DisplayPhotos = [];
    this.UploadPhotos = [];

    if (this.runtimeProvider.IsCors())
    {
      if (this.consoleLog) console.log('mycamera.Initialize: CORS - do not use Native camera');
      this.ShowNativeCamera = false;
    }
    else if (this.runtimeProvider.IsNative())
    {
      if (this.consoleLog) console.log('mycamera.Initialize: NATIVE (and NOT CORS)');
      this.ShowNativeCamera = true;
    }
    else
    {
      if (this.consoleLog) console.log('mycamera.Initialize: BROWSER');
      this.ShowNativeCamera = false;
    }
  }

  GetNativePhotoCameraOptions():CameraOptions
  {
    if (this.consoleLog) console.log('mycamera.GetNativePhotoCameraOptions');

    let options:CameraOptions = 
    { // picture quality in range 0-100
      quality: 50    
      // DATA_URL: 0 (number) - base64-encoded string
      // FILE_URI: 1 (number) - image file URI
      // NATIVE_URI: 2 (number) - image native URI
    , destinationType: this.camera.DestinationType.DATA_URL // FILE_URI
      // JPEG:0 (number) | PNG:1 (number) 
    , encodingType: this.camera.EncodingType.JPEG
      // Only works when Picture Source Type is PHOTOLIBRARY or  SAVEDPHOTOALBUM.  
      // PICTURE: 0  |  VIDEO: 1  
    , mediaType: this.camera.MediaType.PICTURE
      // PHOTOLIBRARY : 0  |  CAMERA : 1  |  SAVEDPHOTOALBUM : 2 
    , sourceType: this.camera.PictureSourceType.CAMERA   // <<<<<<< 
    , allowEdit: true
    , targetWidth: 500
    , targetHeight: 500
    , saveToPhotoAlbum: true
    , correctOrientation: true  //Corrects Android orientation quirks
    //, popoverOptions: CameraPopoverOptions
    };
    return options;
  }

  GetNativePhotoSelectOptions():CameraOptions
  {
    if (this.consoleLog) console.log('mycamera.GetNativePhotoSelectOptions');

    let options:CameraOptions = 
    { // picture quality in range 0-100
      quality: 50    
      // DATA_URL: 0 (number) - base64-encoded string
      // FILE_URI: 1 (number) - image file URI
      // NATIVE_URI: 2 (number) - image native URI
    , destinationType: this.camera.DestinationType.DATA_URL // .FILE_URI
      // JPEG:0 (number) | PNG:1 (number) 
    , encodingType: this.camera.EncodingType.JPEG
      // Only works when Picture Source Type is PHOTOLIBRARY or  SAVEDPHOTOALBUM.  
      // PICTURE: 0  |  VIDEO: 1  
    , mediaType: this.camera.MediaType.PICTURE
      // PHOTOLIBRARY : 0  |  CAMERA : 1  |  SAVEDPHOTOALBUM : 2 
    , sourceType: this.camera.PictureSourceType.PHOTOLIBRARY  // <<<<<<<  
    , allowEdit: true
    , targetWidth: 500
    , targetHeight: 500
    , saveToPhotoAlbum: true
    , correctOrientation: true  //Corrects Android orientation quirks
    //, popoverOptions: CameraPopoverOptions
    };
    return options;
  }

  // Get content type of base64 image data  
  getContentType(Base64ImageData: any) 
  { 
    // Base64ImageData:
    //    data:image/png;base64,iVBORw0KG........
    //    data:image/jpeg;base64,kmHNq8Rts........
    
    let block = Base64ImageData.split(";");     // data:image/png
    let contentType = block[0].split(":")[1];   // image/png
    return contentType;  // image/png
  }  

  getRawBase64ImageData(Base64ImageData: any)
  {
    /* 
    * Taken from http://stackoverflow.com/questions/5867534/how-to-save-canvas-data-to-file/5971674#5971674
    */

    //let fs = require('fs');
    // string generated by canvas.toDataURL()
    // e.g. Base64ImageData = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAKElEQVQ4jWNgYGD4Twzu6FhFFGYYNXDUwGFpIAk2E4dHDRw1cDgaCAASFOffhEIO3gAAAABJRU5ErkJggg==";
    
    // Grab the extension to resolve any image error
    this.FileType = Base64ImageData.split(';')[0].match(/jpeg|png|gif/)[0];

    // strip off the data: url prefix to get just the base64-encoded bytes
    return Base64ImageData.replace(/^data:image\/\w+;base64,/, "");

    // write to file
    //let buf = new Buffer(img, 'base64');
    //fs.writeFile('image.' + ext, buf);
  }

  // Convert base64 data to blob data  
  base64toBlob(base64Data, contentType) 
  {  
      contentType = contentType || '';  
      let sliceSize = 512;  
      let byteCharacters = atob(base64Data);  
      let byteArrays = [];  
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) 
      {  
          let slice = byteCharacters.slice(offset, offset + sliceSize);  
          let byteNumbers = new Array(slice.length);  
          for (let i = 0; i < slice.length; i++) 
          {  
              byteNumbers[i] = slice.charCodeAt(i);  
          }  
          let byteArray = new Uint8Array(byteNumbers);  
          byteArrays.push(byteArray);  
      }  
      let blob = new Blob(byteArrays, {  
          type: contentType  
      });  
      return blob; 
  }

  // ----------------------------------------------------
  // ---------------      PHOTO BUTTONS       -----------
  // ----------------------------------------------------

  // -------------- CORDOVA NATIVE-ONLY BASED PHOTO SELECT  --------------
  btnNativePhotoCamera()
  {
    if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera');
    this.options = this.GetNativePhotoCameraOptions();

    this.Upload_1File_2Base64 = 2;
    if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera: Upload_1File_2Base64=' + this.Upload_1File_2Base64, this.options);

    if (this.consoleLog) console.log("mycamera.btnNativePhotoCamera 1");
    this.camera.getPicture(this.options).then((imageData) => 
    {
      if (this.consoleLog) console.log("mycamera.btnNativePhotoCamera 2");
      if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera - getPicture OK');
      if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera - imageData: ' + imageData);
    
      // ------------------------------------------------------------------------------------------
      // Note that the Base64ImageData here is actually the photo data, which looks like this:
      //    data:image/png;base64,iVBORw0KG........
      //    data:image/jpeg;base64,kmHNq8Rts........
      // For DISPLAY purposes we use Base64ImageData for both NATIVE and BROWSER
      // For UPLOAD purposes we use Base64ImageData for NATIVE, but the FILE for BROWSER
      // ------------------------------------------------------------------------------------------

      // imageData is either a base64 encoded string (DATA_URL) or a file URI
      this.Base64ImageData = imageData;  // using DATA_URL
      if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera - Base64ImageData: ' + this.Base64ImageData);
      
      this.ImgSrcBase64Image = 'data:image/jpeg;base64,' + imageData;  // using DATA_URL
      if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera - ImgSrcBase64Image: ' + this.ImgSrcBase64Image);
      
      this.FileType = "image/jpeg";
      if (this.consoleLog) console.log('mycamera.btnNativePhotoCamera - FileType: ' + this.FileType);

      // *******************************************************
      this.AddPhotoToGallery(this.ImgSrcBase64Image, this.Base64ImageData);
      // *******************************************************
      //this.SetHidePhotoDisplayStatus(false);

      if (this.consoleLog) console.log("mycamera.btnNativePhotoCamera 4");

      // https://github.com/ionic-team/ionic/blob/master/angular/BREAKING.md#resize-was-removed
      /*
        The resize method has been removed from Content. 
        In Ionic 4, the ion-content is based on a flex layout. 
        This means the content size will automatically adjust without requiring a call to resize().
      */
      //if (this.content) { this.content.resize(); }
    }
    , (err) => {
      console.error("mycamera.btnNativePhotoCamera - error", err);
      this.commonProvider.presentToastErrorCatch("Error taking photo (native)", err);
      //alert("mycamera.btnNativePhotoCamera error details " + err.message);
    });
  }

  btnNativePhotoSelect()
  {
    if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect');
    this.options = this.GetNativePhotoSelectOptions();

    this.Upload_1File_2Base64 = 2;
    if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect: Upload_1File_2Base64=' + this.Upload_1File_2Base64, this.options);

    this.camera.getPicture(this.options).then((imageData) => 
    {
      if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect - getPicture OK');
      if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect - imageData' + imageData);
    
      // ------------------------------------------------------------------------------------------
      // Note that the Base64ImageData here is actually the photo data, which looks like this:
      //    data:image/png;base64,iVBORw0KG........
      //    data:image/jpeg;base64,kmHNq8Rts........
      // For DISPLAY purposes we use Base64ImageData for both NATIVE and BROWSER
      // For UPLOAD purposes we use Base64ImageData for NATIVE, but the FILE for BROWSER
      // ------------------------------------------------------------------------------------------

      // imageData is either a base64 encoded string (DATA_URL) or a file URI
      this.Base64ImageData = imageData;  // using DATA_URL
      if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect - Base64ImageData: ' + this.Base64ImageData);
          
      this.ImgSrcBase64Image = 'data:image/jpeg;base64,' + imageData;  // using DATA_URL
      if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect - ImgSrcBase64Image:' + this.ImgSrcBase64Image);
      
      this.FileType = "image/jpeg";
      if (this.consoleLog) console.log('mycamera.btnNativePhotoSelect - FileType: ' + this.FileType);

      // *******************************************************
      this.AddPhotoToGallery(this.ImgSrcBase64Image, this.Base64ImageData);
      // *******************************************************
      //this.SetHidePhotoDisplayStatus(false);
      //if (this.content) { this.content.resize(); }
    }
    , (err) => {
      console.error("mycamera.btnNativePhotoSelect - error", err);
      this.commonProvider.presentToastErrorCatch("Error selecting photo (native)", err);
    });
  }

  btnBrowserPhotoSelect(event) 
  {
    if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect');
    if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - event', event);

    // Note that this is the file that is used for upload to the server
    // only when this.Upload_1File_2Base64 === 1
    this.selectedFile = event.target.files[0];
    
    //let target: any = event.target; //<-- This (any) will tell compiler to shut up!
    //let content: string = target.result;

    if ( (event) && (event.target) && (event.target.files) && (event.target.files[0]) )  
    {
      if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - event.target.files');

      let fileReader = new FileReader();
      fileReader.readAsDataURL(event.target.files[0]); // read file as data url
      fileReader.onload = (event:any) => 
      { 
        // called once readAsDataURL is completed
        if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - onload');
        if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - onload - event', event);
        
        this.zone.run(() => 
        {  
          // ------------------------------------------------------------------------------------------
          // Note that the Base64ImageData here is actually the photo data, which looks like this:
          //    data:image/png;base64,iVBORw0KG........
          //    data:image/jpeg;base64,kmHNq8Rts........
          // For DISPLAY purposes we use Base64ImageData for both NATIVE and BROWSER
          // For UPLOAD purposes we use Base64ImageData for NATIVE, but the FILE for BROWSER
          // ------------------------------------------------------------------------------------------

          this.Base64ImageData = this.getRawBase64ImageData(fileReader.result); // imageData;  // using DATA_URL
          if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - Base64ImageData: ' + this.Base64ImageData);
          
          //this.ImgSrcBase64Image = event.target.result; // I get a typescript error on this unless I add "event:any"
          this.ImgSrcBase64Image = fileReader.result;   // This is valid if I change the datatype for URL to any
          if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - ImgSrcBase64Image: ' + this.ImgSrcBase64Image);
          
          this.FileType = this.getContentType(this.ImgSrcBase64Image);
          if (this.consoleLog) console.log('mycamera.btnBrowserPhotoSelect - FileType: ' + this.FileType);
          
          // *******************************************************
          if (this.globalProvider.UserAppConfig.UsePhotoFileForBrowser === true)
          {
            this.Upload_1File_2Base64 = 1; // only works with browser photo (for now)
            this.AddPhotoToGallery(this.ImgSrcBase64Image, this.selectedFile);
          }
          else
          {
            // I think BOTH Native & Browser are using this....
            this.Upload_1File_2Base64 = 2; // testing to see if we can make browser use same upload as native
            this.AddPhotoToGallery(this.ImgSrcBase64Image, this.Base64ImageData);
          }
          // https://academind.com/learn/angular/snippets/angular-image-upload-made-easy/
          // *******************************************************

          //this.SetHidePhotoDisplayStatus(false);
          //if (this.content) { this.content.resize(); }
        });
      }; 
    }
  }

  /*
  SetHidePhotoDisplayStatus(HidePhotoDisplayOutput:boolean)
  {
    if (this.consoleLog) console.log('mycamera.SetHidePhotoDisplayStatus:' + HidePhotoDisplayOutput);
    this.HidePhotoDisplayOutput = HidePhotoDisplayOutput;
    this.outPhotoCount.emit(this.HidePhotoDisplayOutput);
  }
  */

  btnRemovePhoto(index:number)
  {
    if (this.consoleLog) console.log("MyCamera.btnRemovePhoto: " + index);
    this.DisplayPhotos.splice(index, 1);
    this.UploadPhotos.splice(index, 1);

    if (this.consoleLog) console.log("MyCamera.btnRemovePhoto: after count " + this.DisplayPhotos.length);
    this.PhotoTotal = this.DisplayPhotos.length;
    this.outPhotoCount.emit(this.DisplayPhotos.length);

    // do we still need these fields anymore?
    this.selectedFile = null;
    this.Base64ImageData = null;
    this.ImgSrcBase64Image = null;
  }

  AddPhotoToGallery(base64Image:any, imgSrcBase64Image:any)
  {
    if (this.consoleLog) console.log("MyCamera.AddPhotoToGallery", this.DisplayPhotos);
    this.DisplayPhotos.push(base64Image);
    this.UploadPhotos.push(imgSrcBase64Image);

    this.DisplayPhotos.reverse();
    this.UploadPhotos.reverse();

    if (this.consoleLog) console.log("MyCamera.AddPhotoToGallery: after count " + this.DisplayPhotos.length);
    this.PhotoTotal = this.DisplayPhotos.length;
    this.outPhotoCount.emit(this.DisplayPhotos.length);
  }

  public NotifySubscribersOfUploadStatus(index:number, isSuccess:boolean, apiResponse:any)
  {
    if (this.consoleLog) console.log("MyCamera.NotifySubscribersOfUploadStatus[" + index + "] " + "Success:" + isSuccess); 
    
    // decode the response to see if it's from the server or something went wrong
    if (isSuccess)
    {
      if (apiResponse.ApiReturn) 
      {
        if (apiResponse.ApiReturn.ApiSuccessFlag === true)
        {
          this.PhotoUploadStatus.SuccessFlag = true;
          this.PhotoUploadStatus.StatusText = apiResponse.ApiReturn.ApiReturnText;
        }
        else
        {
          this.PhotoUploadStatus.SuccessFlag = false;
          this.PhotoUploadStatus.StatusText = apiResponse.ApiReturn.ApiReturnText;
        }
      }

      if (apiResponse.MobileMedia) 
      {
        this.PhotoUploadStatus.MobileMediaId = apiResponse.MobileMedia.MobileMediaId;
        this.PhotoUploadStatus.AmbitFileName = apiResponse.MobileMedia.AmbitFileName;
      }
      else
      {
        this.PhotoUploadStatus.MobileMediaId = 0;
        this.PhotoUploadStatus.AmbitFileName = "";
      }

    }
    else
    {
      this.PhotoUploadStatus.SuccessFlag = false;
      this.PhotoUploadStatus.StatusText = apiResponse;  // this will be just an error message
      this.PhotoUploadStatus.MobileMediaId = 0;
      this.PhotoUploadStatus.AmbitFileName = "";
    }

    // update the progress counts
    this.PhotoUploadStatus.UploadAttemptCount++;
    if (this.PhotoUploadStatus.SuccessFlag) 
    { 
      this.PhotoUploadStatus.UploadSuccessCount++; 
    }
    else           
    { 
      this.PhotoUploadStatus.UploadErrorCount++; 
    }

    // set the completed flag
    this.PhotoUploadStatus.PhotoTotal = this.PhotoTotal;
    if (this.PhotoUploadStatus.UploadAttemptCount === this.PhotoTotal)
    {
      this.PhotoUploadStatus.UploadComplete = true;
    }

    console.log("MyCamera.NotifySubscribersOfUploadStatus[" + index + "] " 
               + "Success:" + this.PhotoUploadStatus.SuccessFlag 
               + " UploadProgressCount:" + this.PhotoUploadStatus.UploadAttemptCount
               + "/" + this.PhotoTotal);

    this.outPhotoUploadStatus.emit(this.PhotoUploadStatus);
  }


  // ----------------------------------------------------
  // -----------   PARENT CALLS INTO CAMERA   -----------
  // ----------------------------------------------------

  public btnTestUploadPhoto()
  {
    this.UploadAllMediaFiles(8, "REPORT", "MobileReportId", "1234");
  }

  public UploadAllMediaFiles(ContextFeatureId:number, ContextFeatureName:string, ContextName:string, ContextId:string)
  {
    // this is called by the parent feature to set the photo parameters
    if (this.consoleLog) console.log('mycamera.UploadMediaFile -' 
                                    + ' ContextFeature:' + ContextFeatureId 
                                    + ' (' + ContextFeatureName + ')'
                                    + ContextName + ':' + ContextId
                                    );
    this.PhotoContext = {};
    this.PhotoContext.ContextFeatureId = ContextFeatureId;     // e.g. 8 
    this.PhotoContext.ContextFeatureName = ContextFeatureName; // "SUPPORT", "REPORT", "ACCESS"
    this.PhotoContext.ContextName = ContextName;   // "MobileSupportId", "MobileReportId", "MobileAccessId"
    this.PhotoContext.ContextId = ContextId;       // MobileSupportId, MobileReportId, MobileAccessId

    if (this.consoleLog) console.log('mycamera.UploadMediaFile: 1File OR 2Base64:' + this.Upload_1File_2Base64);
    
    // TO DO:  call this in a loop, one per picture upload

    for (let i = 0; i < this.UploadPhotos.length; i++) 
    {
      if      (this.Upload_1File_2Base64 === 1) { this.CallUploadMediaFile_AsFile(i);      }
      else if (this.Upload_1File_2Base64 === 2) { this.CallUploadMediaFile_Base64Data(i);  }
      else 
      { 
        this.commonProvider.presentToastError("Cannot upload photo", "Upload type not specified (Upload_1File_2Base64) - programming error"); 
      }
    }

  }

  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------

  public CallUploadMediaFile_AsFile(index:number)
  {
    // NOTE: Now using CallUploadMediaFile_Base64Data for Browser photos
    //       so that both native and browser are as similar as possible

    // ToDo:  make this run in background/async?
    // ToDo:  save photo in local storage and try again if it fails?

    if (this.consoleLog) console.log('MyCamera.CallUploadMediaFile');
    
    this.apiProvider.UploadMediaFile_AsFile
          ( this.PhotoContext.ContextFeatureId, this.PhotoContext.ContextFeatureName
          , this.PhotoContext.ContextId, this.PhotoContext.ContextName
          , this.UploadPhotos[index] //, this.selectedFile 
          )
    .then(data => { 
      console.log("MyCamera.CallUploadMediaFile: completed uploading ", data);
      this.zone.run(() => {
        // done
        this.NotifySubscribersOfUploadStatus(index, true, data);
      });
    }
    , 
    errorMessage => {
      console.error("MyCamera.CallUploadMediaFile[" + index + "] error " + errorMessage);
      let errorResponse = "Media upload failed (file) #" + index;
      this.commonProvider.presentToastError(errorResponse, errorMessage); 

      this.zone.run(() => {
        this.NotifySubscribersOfUploadStatus(index, false, errorResponse);
      });
    });
  }

  public CallUploadMediaFile_Base64Data(index:number)
  {
    if (this.consoleLog) console.log("MyCamera.CallUploadMediaFile_Base64Data[" + index + "]");
    
    this.apiProvider.UploadMediaFile_Base64Data
          ( this.PhotoContext.ContextFeatureId, this.PhotoContext.ContextFeatureName
          , this.PhotoContext.ContextId, this.PhotoContext.ContextName
          , this.UploadPhotos[index] //, this.Base64ImageData
          , this.UploadPhotos[index] //, this.Base64ImageData
          , this.FileType
          )
    .then(data => { 
      if (this.consoleLog) console.log("MyCamera.CallUploadMediaFile_Base64Data[" + index + "] completed uploading ", data);
      this.zone.run(() => {
        // done
        this.NotifySubscribersOfUploadStatus(index, true, data);
      });
    }
    , 
    errorMessage => {
      console.error("MyCamera.CallUploadMediaFile_Base64Data[" + index + "] error " + errorMessage);
      let errorResponse = "Media upload failed (base64) #" + index;
      this.commonProvider.presentToastError(errorResponse, errorMessage); 
      this.zone.run(() => {
        this.NotifySubscribersOfUploadStatus(index, false, errorResponse);
      });
    });
  }
  
  public GetIndex(zeroIndex):number
  {
    return Number(zeroIndex + 1); //.toString(); // return zeroIndex + 1;
  }

}
